export const visit = (vm, at) => {
at({ "cs": { "conversations-visitor-experience-components": { "code-splitting": { "error": { "title": "Nastal probl\xE9m s p\u0159ipojen\xEDm k s\xEDti.", "message": "Zkontrolujte p\u0159ipojen\xED a zkuste to znovu.", "button": "Zkusit znovu" } } } } });
};